import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=d55f3eb4&"
import script from "./Assign.vue?vue&type=script&lang=ts&"
export * from "./Assign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports